const RoutePaths = {
  home: '/',
  access: '/access',
  accessMigration: '/access/migration',
  accessRequest: '/access/request',
  clearCookies: '/clear-cookies',
  devTools: '/dev-tools',
  profile: '/profile',
  profileValidate: '/profile/validate',
  profileInfo: '/profile/info',
  profileConfigureEmployer: '/profile/configure-employeer',
  passwordReset: '/password-reset',
  changeSigninEmail: '/change-signin-email',
  subscriptions: '/subscriptions',
  privacy: '/privacy',
  currentPrivacy: '/privacy/current',
  security: '/security',
  help: '/help',
  faqPage: '/help/:suburi+',
  loginInternal: '/login/internal',
  loginStatsforvalteren: '/login/statsforvalteren',
  postLogout: '/post-logout',
  accessRequests: '/access-requests',
  accessRequestDetail: '/access-requests/:id',
  accessRequestsApproved: '/access-requests/approved',
  underMaintenance: '/under-maintenance',
  createEndUser: '/create-end-user'
};

export default RoutePaths;
